import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceName } from '../model/serviceName';

@Component({
  selector: 'app-table-edit-service',
  templateUrl: './table-edit-service.component.html',
  styleUrls: ['./table-edit-service.component.scss']
})



export class TableEditServiceComponent implements OnInit {
  @Input() serviceData: ServiceName[];
  
  @Input() lookupService:ServiceName[];
  
  @Output() serviceDataChange = new EventEmitter<ServiceName[]>();
  @Output() panelOpenState = new EventEmitter<boolean>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  openState:boolean=false

  displayedColumns: string[] = ['select', 'name'];
  dataSource = new MatTableDataSource<ServiceName>();
  selection = new SelectionModel<ServiceName>(true, []);
  

  constructor() {}

  ngOnInit(): void {    
   
  }

  ngOnChanges(): void {         
    this.dataSource.data=this.lookupService;     
    this.preselect();
  }
  ngAfterViewInit() {
    
    
    this.dataSource.paginator = this.paginator;
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: ServiceName): string {
    if (!row) {
      return `${this.isAllSelected() ? 'Deselect ' : 'Select '}`;
    }
    return `${this.selection.isSelected(row) ? 'Deselect ' : 'Select '}`;

    /*return `${this.selection.isSelected(row) ? 'Deselect ' : 'Select '} row ${
      row.position + 1
    }`;*/
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  emitData() {
    this.serviceDataChange.emit(this.selection.selected);
    this.panelOpenState.emit(false);
  }
  emitpanelOpenState() {
    this.openState=true;
    this.selection.clear();    
    if (this.serviceData.length >= 0) 
      this.selection.select(...this.serviceData);    
  }

  preselect()
  {
    this.selection.clear();    
    if (this.serviceData.length >= 0) 
      this.selection.select(...this.serviceData);    
  }
  closeMe()
  {
    this.openState=false;
  }
}

/*export interface PeriodicElement {
  name: string;
  position: number;

}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: ' Migrant Speech & Debate Grades 11 - 12' },
  { position: 2, name: ' Migrant College & Career Exploration' },
  { position: 3, name: 'Migrant Career Academy - Work Study Program'},
  { position: 4, name: 'Family Literacy Math Night - Topic 1' },
  { position: 5, name: 'Family Literacy Math Night - Topic 2' },
  { position: 6, name: 'Mini Corps Indoor Program' },
  { position: 7, name: 'Migrant Course Completion Case Management Grades 10 - 12' },
  { position: 8, name: ' Migrant Attendance Case Management Grades 9 - 12' },
  { position: 9, name: 'Migrant Career Awareness Workshops Grades 9 - 12' },
  { position: 10, name: 'SSDP Mental Health Workshop' },
];*/
